import React, { Component } from "react";
import { Shimmer } from "react-shimmer";
import { getDateData } from "../common/HelperFunctions";
import Payment from "../common/Payment";

export default class Transactions extends Component {
  render() {
    return (
      <div>
        {this.props.payments ? (
          <>
            {this.props.payments.transactions.length > 0 ? (
              <>
                {[...this.props.payments.transactions]
                  .reverse()
                  .map((transaction) => (
                    <Payment
                      {...transaction}
                      cost={transaction.amount_due}
                      title={transaction.description}
                      mini_text={getDateData(
                        transaction.created_at,
                        false,
                        true
                      )}
                    />
                  ))}
              </>
            ) : (
              <p className="end">You currently have no transactions</p>
            )}
          </>
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}

function Loader() {
  return (
    <>
      <Shimmer height={90} className="r-shimer-service r-shimer-member" />
      <Shimmer height={90} className="r-shimer-service r-shimer-member" />
      <Shimmer height={90} className="r-shimer-service r-shimer-member" />
    </>
  );
}

export { Loader };
